import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import useNativeApp from 'hooks/useNativeApp';
import styles from './PostSelectRole.module.scss';

export default function GoogleButton({ googleOAuthRedirect, redirect }) {
  const { isNativeApp } = useNativeApp();

  // Google blocks OAuth inside WebViews, so the app is email-only.
  if (isNativeApp) return null;

  return (
    <div className={styles.googleButtonContainer}>
      <Button
        className={styles.googleButton}
        bsStyle="primary"
        bsSize={redirect === 'post' ? 'medium' : 'lg'}
        onClick={() => {
          window.onbeforeunload = null;
          googleOAuthRedirect(redirect);
        }}
        style={redirect === 'post' ? { width: '100%' } : {}}
      >
        <div className={styles.innerGoogleButton}>
          <SvgIcon
            icon={'google-icon'}
            size="22"
            style={{ marginRight: '15px', marginLeft: '1px', color: 'white' }}
          />
          Continue with Google
        </div>
      </Button>
    </div>
  );
}
